import { CurrenciesItemI } from '@/modules/register/types/api/RegisterUser'

export default class CurrencyItem {
  code: string
  format: number
  id: number
  prefix: string
  rate: string
  suffix: string
  constructor(item: CurrenciesItemI) {
    this.code = item.code
    this.format = item.format
    this.id = item.id
    this.prefix = item.prefix
    this.rate = item.rate
    this.suffix = item.suffix
  }
}
